<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：商品管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.category_id" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入商品名称"></el-input></el-form-item>
        <el-form-item label="编码"><el-input size="small" v-model="searchForm.product_no" :placeholder="product_no_search"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection"  width="45"></el-table-column>
          <el-table-column prop="product_name" label="产品" width="400px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image[0]?scope.row.image[0].file_path:error_img" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                  <div class="name" v-if="scope.row.supply_id>0">供应商：{{ scope.row.supply?scope.row.supply.name:'' }}
                    <span v-if="scope.row.supply && scope.row.supply.self_manage>0">(自营)</span>
                  </div>
                  <div>  
                    <el-tag size="mini" v-for="(tag,index) in scope.row.labels" :key="tag.name" > {{tag.name}} </el-tag>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="category.name" label="分类"></el-table-column>
          <el-table-column prop="sales_actual" label="实际销量"></el-table-column>
          <el-table-column prop="product_stock" label="库存">
            <template slot-scope="scope">
              <span v-if="scope.row.product_stock <=0">已售罄</span>
              <span v-else>{{scope.row.product_stock}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="view_times" label="点击数"></el-table-column>
          <el-table-column prop="product_status.text" label="商品属性">
            <template slot-scope="scope">
              <span v-if="scope.row.is_virtual == 0">实物商品</span>
              <span v-if="scope.row.is_virtual == 1" class="green">虚拟商品</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="发布时间"></el-table-column>
          <el-table-column prop="product_sort" label="排序"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="reClick(scope.row)" type="text" size="small" >恢复</el-button>
               <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/product/edit'">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import ProductApi from '@/api/product.js';
import qs from 'qs';
export default {
  components: {
  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: '',
        category_id: '',
        product_no:''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      /*选中的*/
      multipleSelection: [],
      /*选择的商品列表*/
      select_list:[],
      /*是否显示*/
      dialogVisible: false,
      open_upload:false,
      // 导入类型
      import_type:'goods',
      // 是否加载操作页面
      more_actions:false,
      product_no_search:'',
      error_img:''//商品默认图
    };
  },
  created() {
    /*获取列表*/
    this.getData();

  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      ProductApi.recycleList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.categoryList = data.data.catgory;
          self.totalDataNumber = data.data.list.total;
          var product_no_text = data.data.product_vars.product_no_text;
          var product_diy_no_text = data.data.product_vars.product_diy_no_text;
          if(!product_no_text){
            product_no_text='商品编码';
          }
          if(!product_diy_no_text){
            product_diy_no_text='商品自编码';
          }
          self.product_no_search = product_no_text+"/"+product_diy_no_text;
          
          if(data.data.product_vars){
              if(data.data.product_vars.product_default_image){
                  if(data.data.product_vars.product_default_image.file_path){
                    self.error_img = data.data.product_vars.product_default_image.file_path;
                  }
                  
              }
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*选择商品*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'edit'
        }
      });
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
        if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }else if(f == 'action'){
          this.more_actions = e.openDialog;
          if (e.type == 'success') {
                this.getData();
          }
        }
    },
    /*删除*/
    reClick: function(row) {
      let self = this;
      self
        .$confirm('确认恢复该商品吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          ProductApi.recGoods({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: '恢复成功',
              type: 'success'
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/recycleindex.vue